import Home from '@/app/features/admin/home/Home.vue';
import ClientPage from '@/app/features/admin/pages/ClientPage.vue';
import RolePage from '@/app/features/admin/pages/RolePage.vue';
import BatchPage from '@/app/features/admin/pages/BatchPage.vue';
import {
  RouteRecordRaw,
  RouteLocationNormalized,
  NavigationGuardNext,
} from 'vue-router';
import UserPage from './pages/UserPage.vue';
import DeployPage from './pages/DeployPage.vue';
import AccessGuard from '@/app/shared/guards/access-guard';
import { AdminSubjects } from '@/app/shared/services/ability-service';
import { FeatureGuard } from '@/app/shared/guards/feature-guard.js';
import { FEATURE_FLAGS } from '@/app/shared/constants/feature-flags';

let adminMountPath = '/admin';

const createAccessGuard =
  (accessKey: AdminSubjects) =>
  (
    _to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    if (AccessGuard.hasAccess(accessKey)) {
      next();
    } else {
      next({ name: 'admin-home' });
    }
  };

const adminRoutes = [
  {
    path: `${adminMountPath}/home`,
    name: 'admin-home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${adminMountPath}/client`,
    name: 'admin-client',
    beforeEnter: createAccessGuard('CLIENT'),
    component: ClientPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${adminMountPath}/role`,
    name: 'admin-role',
    beforeEnter: createAccessGuard('ROLE'),
    component: RolePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${adminMountPath}/batch`,
    name: 'admin-batch',
    beforeEnter: [
      createAccessGuard('BATCH'),
      FeatureGuard.routeGuard(FEATURE_FLAGS.BATCH_AGENT),
    ],
    component: BatchPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${adminMountPath}/users`,
    name: 'admin-users',
    beforeEnter: createAccessGuard('USER'),
    component: UserPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${adminMountPath}/deploy`,
    name: 'admin-deploy',
    component: DeployPage,
    beforeEnter: [
      createAccessGuard('DEPLOY'),
      FeatureGuard.routeGuard(FEATURE_FLAGS.BUREAU_COMPOSER),
    ],
    meta: {
      requiresAuth: true,
    },
  },
];

const getAdminRoutes = (path = '/admin'): Array<RouteRecordRaw> => {
  adminMountPath = path;
  return adminRoutes;
};

export { getAdminRoutes };
